/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'account': 'Account',
    'account_deleted': 'Bitte überprüfe dein Postfach und bestätige die Löschung deines Accounts.',
    'account_hint': 'Dein Passwort kannst du in den {securitySettings} ändern',
    'account_system': 'Kontenrahmen',
    'account_system_hint': 'Falls deine Buchhaltung einen anderen Kontenrahmen nutzt kannst du diesen hier anpassen',
    'account_system_skr_03': 'SKR 03',
    'account_system_skr_04': 'SKR 04',
    'address_hint': 'Diese Adresse wird auf deinen Rechnungen sichtbar sein',
    'algorithm': 'Algorithmus',
    'avatar': 'Profilbild',
    'backup_codes': 'Ersatzcodes',
    'backup_codes_body': 'Solltest du den Zugriff auf dein Zwei-Faktor Gerät verlieren, kannst du einen dieser Codes<br>verwenden um trotzdem Zugriff auf deinen Account zu erhalten. Kopiere dazu die<br>Ersatzcodes und speichere sie in einem Passwortmanager.',
    'bank_details': 'Bankdaten',
    'change_password': 'Passwort ändern',
    'change_password_hint': 'Dein Passwort muss mindestens 6 Zeichen lang sein',
    'contact': 'Kontakt',
    'contact_data': 'Kontaktdaten',
    'contact_hint': 'Wenn diese Daten nicht auf der Rechnung sichtbar sein sollen, kannst du dies in den Rechnungs-Einstellungen ändern',
    'customer_number': 'Kundennummer',
    'customer_number_format': 'Kundennummer Format',
    'customer_number_format_hint': 'Du kannst folgende Platzhalter verwenden:<br><br>Aktuelles Jahr: {{Y}}<br>Aktueller Monat: {{m}}<br>Aktueller Tag: {{d}}<br>Nächste Kundennummer: {{#}}<br><br><b>Beispiel:</b> {{Y}}-{{#}} ergibt ',
    'customer_number_hint': 'Diese Kundenummer wird dem nächsten Kunden zugewisen',
    'customers': 'Kunden',
    'danger_zone': 'Gefahrenzone',
    'delete_account': 'Account löschen',
    'delete_account_hint': 'Wenn du die Löschung deines Accounts beantragst, wird dein Account nach <strong>7 Tagen</strong> vollständig gelöscht.<br><br> Innerhalb dieses Zeitraums kannst du deinen Account bereits nicht mehr nutzen, er kann aber durch den Support wiederhergestellt werden.<br> Von dir angelegte Kunden, Rechnungen, etc. bleiben deiner Firma erhalten.',
    'delete_image': 'Aktuelles {type} löschen.',
    'digits': 'Zeichen',
    'email_confirmed_body': 'Du wirst in 5 Sekunden automatisch weitergeleitet.',
    'email_confirmed_title': 'E-Mail Adresse geändert',
    'general': 'Allgemein',
    'image_deleted': '{type} wurde gelöscht.',
    'image_hint': 'Zum ändern das Bild anklicken',
    'image_stored': '{type} wurde gespeichert.',
    'interval': 'Intervall',
    'invite_accepted_accountant': 'Einladung wurde angenommen',
    'invite_open_accountant': 'Einladung wurde noch nicht angenommen',
    'invoice_number_format_hint': 'Du kannst folgende Platzhalter verwenden:<br><br>Aktuelles Jahr (vierstellig): {{Y}}<br>Aktuelles Jahr (zweistellig): {{y}}<br>Aktueller Monat: {{m}}<br>Aktueller Tag: {{d}}<br>Fortlaufende Rechnungsnummer: {{#}}<br><br><b>Beispiel:</b> {{Y}}-{{#}} ergibt ',
    'invoice_number_hint': 'Du kannst die Rechnungsnummer für jede Rechnung anpassen',
    'invoicing': 'Rechnungen',
    'language': 'Sprache',
    'language_hint': 'Wir werden die Sprache als Standard für deine Rechnungen verwenden',
    'logo': 'Logo',
    'logo_hover': 'Zum ändern Logo anklicken',
    'mode': 'Modus',
    'next_account_payable_number': 'Nächste Kreditorennummer',
    'next_account_receivable_number': 'Nächste Debitorennummer',
    'next_customer_number': 'Nächste Kundennummer',
    'otp_enable_body': 'Verwende eine beliebige Time-based One-time Password (TOTP) App wie Google Authenticator, Microsoft Authenticator oder FreeOTP um den QR-Code zu scannen. Trage anschließen den 6-stelligen Code in das untenstehende Feld ein.',
    'otp_enable_hint': 'Solltest du Probleme haben den Code zu scannen, versuche die App {manualSetup} einzurichten.',
    'otp_enable_manual': 'manuell',
    'otp_enable_title': 'Zwei-Faktor-Authentifizierung aktivieren',
    'otp_hint': 'Zwei-Faktor Authentifizierung kann dabei helfen deinen Account und deine Daten vor unberechtigtem Zugriff zu schützen, indem du bei jedem Login zusätzlich zu deinem Passwort einen 6-stelligen Code eingeben musst.<br><br>' +
      'Um Zwei-Faktor Authentifizierung zu nutzen, kannst du eine beliebige Time-based One-time Password (TOTP) App, wie Google Authenticator, Microsoft Authenticator oder FreeOTP benutzen.',
    'payment': 'Zahlung | Zahlungen',
    'payment_deadline': 'Zahlungsziel',
    'payment_deadline_hint': 'Dies ist das standard Zahlungsziel aller Rechnung. Du kannst zusätzlich für jeden Kunden ein individuelles Zahlungsziel festlegen.',
    'quote_deadline': 'Angebotsdauer',
    'quote_deadline_hint': 'Dies ist die standard Zeitspanne für die Angebote gültig sind. Du kannst zusätzlich für jeden Kunden eine individuelle Gültigkeitsdauer festlegen.',
    'quote_number_format_hint': 'Du kannst folgende Platzhalter verwenden:<br><br>Aktuelles Jahr (vierstellig): {{Y}}<br>Aktuelles Jahr (zweistellig): {{y}}<br>Aktueller Monat: {{m}}<br>Aktueller Tag: {{d}}<br>Fortlaufende Auftragsnummer: {{#}}<br><br><b>Beispiel:</b> {{Y}}-{{#}} ergibt ',
    'regenerate_codes': 'Codes erneuern',
    'registration_court': 'Amtsgericht',
    'registration_number': 'Handelsregisternr.',
    'reset_invoice_numbers': 'Rechnungsnummern zurücksetzen',
    'reset_monthly': 'Monatlich zurücksetzen',
    'reset_never': 'Nie zurücksetzen',
    'reset_quote_numbers': 'Angebotsnummern zurücksetzen',
    'reset_yearly': 'Jährlich zurücksetzen',
    'secret': 'Secret',
    'security': 'Sicherheit',
    'security_settings': 'Sicherheits Einstellungen',
    'setting': 'Einstellung | Einstellungen',
    'settings_save_success': 'Deine Benutzerdaten wurde aktualisiert.',
    'settings_save_success_email': 'Bitte überprüfe dein Postfach und bestätige deine neue E-Mail-Adresse.',
    'tax_advisor': 'Steuerberater',
    'tax_advisor_email': 'E-Mail deines Steuerberaters',
    'tax_advisor_hint': 'Deine Steuerberater kann alle Dokumente zu deiner Firma einsehen, jedoch keinerlei Änderungen innerhalb von likvi vornehmen',
    'tax_number': 'Steuernummer',
    'team_hint': 'Diese Daten werden unter anderem auf deinen Rechnungen sichtbar sein',
    'team_settings_save_success': 'Die Firmen Einstellungen wurden gespeichert.',
    'vat_number': 'USt-IdNr.',
    'watermark': 'Wasserzeichen',
    'watermark_hover': 'Zum ändern Wasserzeichen anklicken'
  },

  /* english */
  en: {
    'account': 'Account',
    'account_deleted': 'Please check you inbox and confirm your the account deletion.',
    'account_hint': 'To change your password, please see your {securitySettings}',
    'account_system': 'Account system',
    'account_system_hint': 'If you use a different account system you can configure that here',
    'account_system_skr_03': 'SKR 03',
    'account_system_skr_04': 'SKR 04',
    'address_hint': 'Your clients will see this address on your invoices',
    'algorithm': 'Algorithm',
    'avatar': 'Avatar',
    'backup_codes': 'Backup Codes',
    'backup_codes_body': 'If you loose access to your Two-Factor device, you can use one of the backup codes to access your account.<br>Copy the backup codes and save them in a password manager such as LastPass or KeePass.',
    'bank_details': 'Bank Details',
    'change_password': 'Change Password',
    'change_password_hint': 'Your password must be at least 6 characters long',
    'contact': 'Contact',
    'contact_data': 'Contact Data',
    'contact_hint': 'If you don\'t want to your contact data to be displayed on your invoices, you can change that in your invoice settings',
    'customer_number': 'Customer Number',
    'customer_number_format': 'Customer Number Format',
    'customer_number_format_hint': 'The following placeholders are available:<br><br>Current Year: {{Y}}<br>Current Month: {{m}}<br>Current Day: {{d}}<br>Next Customer Number: {{#}}<br><br><b>Example:</b> {{Y}}-{{#}} yields ',
    'customer_number_hint': 'The customer number that will be assigned to the next customer you create',
    'customers': 'Customers',
    'danger_zone': 'Danger Zone',
    'delete_account': 'Delete Account',
    'delete_account_hint': 'Your account will be removed <strong>7 days</strong> after requesting the deletion.<br><br> Within this period, you will not be able to use your account anymore, however, your account may be restored by the support team if you file an according request.<br> All customers, invoices, etc. created by you will still be available for other company members even after your account has been removed.',
    'delete_image': 'Delete your current {type}.',
    'digits': 'Digits',
    'email_confirmed_body': 'You will be redirected automatically in 5 seconds.',
    'email_confirmed_title': 'E-Mail Address Updated',
    'general': 'General',
    'image_deleted': '{type} has been deleted.',
    'image_hint': 'Hover the image to change it',
    'image_stored': '{type} has been stored.',
    'interval': 'Interval',
    'invite_accepted_accountant': 'Invite was accepted',
    'invite_open_accountant': 'Invite was not yet accepted',
    'invoice_number_format_hint': 'The following placeholders are available:<br><br>Current year (four-digit): {{Y}}<br>Current year (double-digit): {{y}}<br>Current month: {{m}}<br>Current day: {{d}}<br>Consecutive invoice number: {{#}}<br><br><b>Example:</b> {{Y}}-{{#}} yields ',
    'invoice_number_hint': 'You can change the pre-filled value on a per invoice basis.',
    'invoicing': 'Invoicing',
    'language': 'Language',
    'language_hint': 'We will use the language as a default for your invoices',
    'logo': 'Logo',
    'logo_hover': 'Hover the logo to update',
    'mode': 'Mode',
    'next_account_payable_number': 'Next Account Payable Number',
    'next_account_receivable_number': 'Next Account Receivable Number',
    'next_customer_number': 'Next Customer Number',
    'otp_enable_body': 'Use any Time-based One-time Password (TOTP) compatible two-factor authentication app such as Google Authenticator, Microsoft Authenticator or FreeOTP to scan the QR code. Enter the 6 digit code you have received below.',
    'otp_enable_hint': 'If you are having trouble scanning the QR code, try setting it up {manualSetup}.',
    'otp_enable_manual': 'manually',
    'otp_enable_title': 'Enable Two-Factor Authentication',
    'otp_hint': 'Two-Factor Authentication can help to protect your account and your data from unauthorized accessed by requiring a 6-digit code in addition to your password at each login.<br><br>' +
      'In order to use Two-Factor Authentication, you can use any Time-based One-time Password (TOTP) app, like Google Authenticator, Microsoft Authenticator or FreeOTP.',
    'payment': 'Payment | Payments',
    'payment_deadline': 'Payment Deadline',
    'payment_deadline_hint': 'The default payment deadline for your invoices. You can change the payment deadline for each customer individually as well.',
    'quote_deadline': 'Quote Deadline',
    'quote_deadline_hint': 'The default timespan for which quotes will be valid. You can set the deadline for each customer individually as well',
    'quote_number_format_hint': 'The following placeholders are available:<br><br>Current year (four-digit): {{Y}}<br>Current year (double-digit): {{y}}<br>Current month: {{m}}<br>Current day: {{d}}<br>Consecutive quote number: {{#}}<br><br><b>Example:</b> {{Y}}-{{#}} yields ',
    'regenerate_codes': 'Regenerate Codes',
    'registration_court': 'Registration Court',
    'registration_number': 'Registration ID',
    'reset_invoice_numbers': 'Reset invoice number',
    'reset_monthly': 'Reset monthly',
    'reset_never': 'Reset never',
    'reset_quote_numbers': 'Reset quote number',
    'reset_yearly': 'Reset yearly',
    'secret': 'Secret',
    'security': 'Security',
    'security_settings': 'Security settings',
    'setting': 'Setting | Settings',
    'settings_save_success': 'Your personal information has been updated.',
    'settings_save_success_email': 'Please check you inbox and confirm your new e-mail address.',
    'tax_advisor': 'Tax Adviser',
    'tax_advisor_email': "Your tax adviser's email",
    'tax_advisor_hint': 'Your tax adviser can view all your companies documents but not modify any of the data in likvi.',
    'tax_number': 'Tax ID',
    'team_hint': 'This information will be visible on your invoices',
    'team_settings_save_success': "Your company's settings have been updated.",
    'vat_number': 'VAT ID',
    'watermark': 'Watermark',
    'watermark_hover': 'Hover the watermark to update it'
  }
}
